import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { AnnualAccountFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { TextInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { TextAreaInput, VerticalFormField, useWintForm, WintForm } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AnnualAccountOrderK10Form: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const { wintFormProps, connect } = useWintForm<AnnualAccountFormTypes.Comment>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.validationSchema,
    handleSubmit: props.handleSubmit,
    onFormValidationChange: props.onFormValidationChange,
  });

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<TextInputProps>
        Component={TextAreaInput}
        {...connect("message")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderCommentLabel)}
      />
    </WintForm>
  );
};

export default forwardRef(AnnualAccountOrderK10Form);
